// @flow

import type {LocaleKeys} from '../../utils/types/locale';
import type {PayloadAction} from '../types';
import type {ApplicationState} from './types';

type ActionLocaleSuccess = PayloadAction<'@publisher/application/locale/success', LocaleKeys>;

type Actions = ActionLocaleSuccess;

const initialState: ApplicationState = {
  locale: 'en',
  isFetching: false
};

export default (state: ApplicationState = initialState, action: Actions) => {
  switch (action.type) {
    case '@publisher/application/locale/success':
      return {...state, isFetching: false, locale: action.payload};
    default:
      return state;
  }
};

// Actions

export const applicationLocale = (payload: LocaleKeys): ActionLocaleSuccess => ({
  type: '@publisher/application/locale/success',
  payload
});
